export default "__VITE_ASSET__D72ORnz1__"